<template>
  <b-container
    fluid
  >
    <div class="d-flex justify-content-end mb-0 pb-0">
      <b-breadcrumb
        v-if="$route.meta.breadcrumb"
        :items="$route.meta.breadcrumb || []"
      />
    </div>

    <b-container fluid>
      <b-row>
        <b-col
          cols="12"
          class="px-1"
        >
          <b-form-group
            label="Search"
            label-for="filter_tax_code_search"
            label-class="font-weight-bolder"
          >
            <b-input
              id="filter_tax_code_search"
              v-model="tableTaxCode.filter.search"
              type="text"
              placeholder="search here"
              debounce="1000"
              autocomplete="off"
            />
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          class="px-1 mb-2"
        >
          <b-button
            size="sm"
            type="button"
            variant="success"
            @click="onCreateTaxCode"
          >
            Add Tax Code
          </b-button>
        </b-col>
      </b-row>

      <b-row>
        <b-col
          cols="12"
          class="px-1"
        >
          <b-table
            ref="tableTaxCode"
            hover
            small
            striped
            bordered
            responsive
            show-empty
            :stacked="isMobile()"
            :per-page="tableTaxCode.perPage"
            :current-page="tableTaxCode.currentPage"
            :items="tableTaxCodeProvider"
            :fields="tableTaxCode.fields"
            :sort-by.sync="tableTaxCode.sortBy"
            :sort-desc.sync="tableTaxCode.sortDesc"
            :sort-direction="tableTaxCode.sortDirection"
            :filter="tableTaxCode.filter"
            :filter-included-fields="tableTaxCode.filterOn"
            :busy="tableTaxCode.busy"
          >
            <template #cell(index)="row">
              {{ tableTaxCode.currentPage * tableTaxCode.perPage - tableTaxCode.perPage + (row.index + 1) }}
            </template>

            <template #cell(active)="row">
              {{ Number(row.value) === 1 ? 'Yes' : 'No' }}
            </template>

            <template #cell()="row">
              <div class="text-md-nowrap">
                {{ row.value }}
              </div>
            </template>

            <template #cell(action)="row">
              <div class="text-md-nowrap d-flex flex-column flex-md-row justify-content-center">
                <b-button
                  size="sm"
                  variant="success"
                  @click="onEditTaxCode(row.item)"
                >
                  Edit
                </b-button>
              </div>
            </template>

            <template #table-busy>
              <div class="text-center py-5">
                <b-icon
                  icon="stopwatch"
                  font-scale="5"
                  animation="cylon"
                />
                <p class="h3 py-2">
                  <strong>Loading . . .</strong>
                </p>
              </div>
            </template>

          </b-table>
        </b-col>
        <b-col
          cols="12"
          md="6"
          class="mt-1 mb-2 px-1"
        >
          <b-select
            v-model="tableTaxCode.perPage"
            :options="tableTaxCode.pageOptions"
            class="w-100 w-md-25"
          />
        </b-col>
        <b-col
          cols="12"
          md="6"
          class="d-flex justify-content-center justify-content-md-end mt-1 px-1"
        >
          <b-pagination
            v-model="tableTaxCode.currentPage"
            pills
            last-number
            first-number
            prev-text="Prev"
            next-text="Next"
            aria-controls="table"
            :total-rows="tableTaxCode.totalRows"
            :per-page="tableTaxCode.perPage"
          />
        </b-col>
      </b-row>
    </b-container>

    <b-modal
      id="modal-tax-code"
      scrollable
      no-close-on-esc
      no-enforce-focus
      hide-header-close
      no-close-on-backdrop
      :title="ModalTaxCodeTitle"
    >
      <ValidationObserver
        ref="formTaxCode"
      >
        <form
          role="form"
          novalidate
          @submit.prevent
        >
          <b-row>
            <b-col
              cols="12"
            >
              <ValidationProvider
                #default="{ errors }"
                name="tax code"
                vid="code"
                rules="required|max:20"
              >
                <b-form-group
                  label="Code"
                  label-for="tax_code"
                  label-class="font-weight-bolder"
                  class="mb-2"
                >
                  <b-input
                    id="tax_code"
                    v-model="taxCode.code"
                    type="text"
                    maxlength="20"
                    autocomplete="off"
                    placeholder="enter code here"
                    :state="errors.length > 0 ? false : null"
                    :disabled="state.busy"
                  />
                  <div
                    v-if="errors.length > 0"
                    class="invalid-feedback"
                  >
                    <span>{{ errors[0] }}</span>
                  </div>
                </b-form-group>
              </ValidationProvider>
            </b-col>
            <b-col
              cols="12"
            >
              <ValidationProvider
                #default="{ errors }"
                name="description"
                vid="description"
                rules="required|max:20"
              >
                <b-form-group
                  label="Description"
                  label-for="description"
                  label-class="font-weight-bolder"
                  class="mb-2"
                >
                  <b-input
                    id="description"
                    v-model="taxCode.description"
                    type="text"
                    maxlength="20"
                    autocomplete="off"
                    placeholder="enter description here"
                    :state="errors.length > 0 ? false : null"
                    :disabled="state.busy"
                  />
                  <div
                    v-if="errors.length > 0"
                    class="invalid-feedback"
                  >
                    <span>{{ errors[0] }}</span>
                  </div>
                </b-form-group>
              </ValidationProvider>
            </b-col>
            <b-col
              cols="12"
            >
              <ValidationProvider
                #default="{ errors }"
                name="type"
                vid="code_type"
                rules="required"
              >
                <b-form-group
                  label="Type"
                  label-for="code_type"
                  label-class="font-weight-bolder"
                  class="mb-2"
                >
                  <b-form-select
                    id="code_type"
                    v-model="taxCode.code_type"
                    :options="lists.code_types"
                    :state="errors.length > 0 ? false : null"
                    :disabled="state.busy"
                  >
                    <template #first>
                      <b-form-select-option
                        :value="null"
                        disabled
                      >
                        -- select type here --
                      </b-form-select-option>
                    </template>
                  </b-form-select>
                  <div
                    v-if="errors.length > 0"
                    class="invalid-feedback"
                  >
                    <span>{{ errors[0] }}</span>
                  </div>
                </b-form-group>
              </ValidationProvider>
            </b-col>
            <b-col
              cols="12"
            >
              <ValidationProvider
                #default="{ errors }"
                name="percentage"
                vid="percentage"
                rules="required|double"
              >
                <b-form-group
                  label="Percentage"
                  label-for="percentage"
                  label-class="font-weight-bolder"
                  class="mb-2"
                >
                  <b-input
                    id="percentage"
                    v-model="taxCode.percentage"
                    type="number"
                    step="0.01"
                    autocomplete="off"
                    placeholder="enter percentage"
                    :state="errors.length > 0 ? false : null"
                  />
                  <div
                    v-if="errors.length > 0"
                    class="invalid-feedback"
                  >
                    <span>{{ errors[0] }}</span>
                  </div>
                </b-form-group>
              </ValidationProvider>

            </b-col>
            <b-col
              v-if="state.editing"
              cols="12"
            >
              <b-form-group>
                <b-form-checkbox
                  id="is_active"
                  v-model="taxCode.active"
                  name="is_active"
                  value="1"
                  unchecked-value="0"
                  :disabled="state.busy"
                  switch
                >
                  Is Active?
                </b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>
        </form>
      </ValidationObserver>

      <template #modal-footer="{cancel}">
        <b-button
          variant="success"
          :disabled="state.busy"
          @click="onValidateTaxCode"
        >
          {{ state.editing ? 'Update Record' : 'Save Record' }}
        </b-button>
        <b-button
          variant="outline-dark"
          :disabled="state.busy"
          @click="cancel()"
        >
          Close Window
        </b-button>
      </template>

    </b-modal>
  </b-container>
</template>

<script>
import QUERY from 'lodash'
import { core } from '@/config/pluginInit'

import formatter from '@/mixins/formatter'
import misc from '@/mixins/misc'

import { STATaxCode } from '@/services'

export default {
  name: 'TaMaintenancesTaxCodes',

  middleware: ['auth', 'ta'],

  mixins: [formatter, misc],

  metaInfo: () => ({
    title: 'Tax Codes'
  }),

  data () {
    return {
      state: {
        busy: false,
        editing: false
      },
      lists: {
        code_types: [
          { text: 'Individual', value: 'Individual' },
          { text: 'Corporation', value: 'Corporation' }
        ]
      },
      taxCode: {
        id: null,
        code: null,
        description: null,
        percentage: 0,
        active: 1
      },
      tableTaxCode: {
        perPage: 10,
        pageOptions: [10, 25, 50, 100],
        totalRows: 0,
        currentPage: 1,
        sortBy: null,
        sortDesc: false,
        sortDirection: 'asc',
        filter: {
          search: null
        },
        filterOn: [],
        busy: false,
        fields: [
          { mobile: 0, key: 'index', label: '#', class: 'text-center' },
          { mobile: 8, key: 'action', class: 'text-center' },
          { mobile: 1, key: 'created_at', formatter: this.dateTimeShortFormatter, sortable: true },
          { mobile: 2, key: 'code' },
          { mobile: 3, key: 'description' },
          { mobile: 4, key: 'code_type', label: 'Type' },
          { mobile: 5, key: 'percentage' },
          { mobile: 6, key: 'active', class: 'text-center' },
          { mobile: 7, key: 'updated_at', formatter: this.dateTimeShortFormatter, sortable: true }
        ].sort(this.scaleOnMobile)
      }
    }
  },

  computed: {
    ModalTaxCodeTitle () {
      return this.state.editing ? 'Edit Tax Code' : 'Add Tax Code'
    }
  },

  mounted () {
    core.index()
  },

  methods: {
    async tableTaxCodeProvider ({ currentPage, perPage, sortBy, sortDesc, filter }) {
      this.tableTaxCode.busy = true
      return await STATaxCode.get(
        this.objectToUrl({
          page: currentPage,
          per_page: perPage,
          sort: sortBy,
          sort_desc: sortDesc,
          filter_text: filter.search
        })
      ).then(({ data }) => {
        this.tableTaxCode.totalRows = data.total_rows
        return data.items
      }).catch(() => []).finally(() => {
        this.tableTaxCode.busy = false
      })
    },

    onCreateTaxCode () {
      this.state.editing = false
      this.taxCode.id = null
      this.taxCode.code = null
      this.taxCode.code_type = null
      this.taxCode.description = null
      this.taxCode.percentage = 0
      this.taxCode.active = 1
      this.$bvModal.show('modal-tax-code')
    },

    onEditTaxCode (taxCode) {
      this.state.editing = true
      this.taxCode.id = taxCode.id
      this.taxCode.code = taxCode.code
      this.taxCode.code_type = taxCode.code_type
      this.taxCode.description = taxCode.description
      this.taxCode.percentage = taxCode.percentage
      this.taxCode.active = taxCode.active
      this.$bvModal.show('modal-tax-code')
    },

    async onValidateTaxCode (bvModalEvt) {
      bvModalEvt.preventDefault()
      await this.$refs.formTaxCode.validate().then(
        async allFieldsAreValid => {
          if (allFieldsAreValid) {
            this.swalConfirm({
              html: () => {
                if (this.state.editing) {
                  return '<h6>Save your Changes on this Tax Code?</h6>'
                }
                return '<h6>Create this Tax Code?</h6>'
              },
              preConfirm: () => {
                this.state.busy = true
                if (this.state.editing) {
                  return this.onPutTaxCode()
                }
                return this.onPostTaxCode()
              }
            })
          } else {
            this.swalInvalid()
          }
        }
      )
    },

    async onPostTaxCode () {
      return new Promise(resolve => {
        STATaxCode.post(this.taxCode).then(({ data: { message } }) => {
          this.$refs.tableTaxCode.refresh()
          this.swalSuccess(message).then(() => {
            this.$bvModal.hide('modal-tax-code')
          })
          resolve(message)
        }).catch(({ message }) => {
          this.$refs.formTaxCode.setErrors(message)
          resolve(message)
        }).finally(() => {
          this.state.busy = false
        })
      })
    },

    async onPutTaxCode () {
      return new Promise(resolve => {
        STATaxCode.put(this.taxCode).then(({ data }) => {
          const tableTaxCodeRow = QUERY.find(this.$refs.tableTaxCode.localItems, { id: data.tax_code.id })
          if (tableTaxCodeRow) {
            tableTaxCodeRow.code = data.tax_code.code
            tableTaxCodeRow.code_type = data.tax_code.code_type
            tableTaxCodeRow.description = data.tax_code.description
            tableTaxCodeRow.percentage = data.tax_code.percentage
            tableTaxCodeRow.active = data.tax_code.active
            tableTaxCodeRow.updated_at = data.tax_code.updated_at
          }
          this.swalSuccess(data.message).then(() => {
            this.$bvModal.hide('modal-tax-code')
          })
          resolve(data)
        }).catch(({ message }) => {
          this.$refs.formTaxCode.setErrors(message)
          resolve(message)
        }).finally(() => {
          this.state.busy = false
        })
      })
    }
  }
}
</script>
